// removed by extract-text-webpack-plugin
module.exports = {"container":"ServiceView__container___1_6ql"};